module.exports = __webpack_public_path__ + "static/media/check.8f679e44.svg";